import { requestApi } from '../util/network'

export const getGoodsList =
    (params, other) =>
      requestApi(
        '/o2o_fuwu_goods/get_list',
        'POST',
        Object.assign(
          {
            page: params.page,
            per_page: params.per_page
          },
          other)
      )

export const getGoodsInfo =
    (o2o_fuwu_goods_id) =>
      requestApi(
        '/o2o_fuwu_goods/get_info',
        'POST',
        {
          o2o_fuwu_goods_id: o2o_fuwu_goods_id
        }
      )
